import formatTime from "mn-utils/formatTime";
import getDateRange from "../../../../../dumb/IntervalFilterCustom/utils/getDateRange";

export const handleFiltersData = (filters) => {
  let {interval, from, to, ...rest} = filters;

  const {
    getRFC3339,
  } = formatTime;

  if ((!from || !to) && interval) {
    const params = getDateRange({interval});
    from = params.from;
    to = params.to;
  }

  return {
    from: from ? getRFC3339(from) : null,
    to: to ? getRFC3339(to) : null,
    ...rest
  }
}
